module.exports = __webpack_public_path__ + "static/media/6.0f6020a.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mp4/6.mp4
// module id = h3kc
// module chunks = 1